import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ReportDetailContainerComponent } from './containers/report-detail-container/report-detail-container.component';
import { ReportsOverviewContainerComponent } from './containers/reports-overview-container/reports-overview-container.component';

const routes: Routes = [
    {
        path: '',
        component: ReportsOverviewContainerComponent
    },
    {
        path: ':id',
        component: ReportDetailContainerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReportsRoutingModule {}
